import { useState } from "react";
import { ExternalLink } from "lucide-react";
import { assetUrl } from "@/lib/api";

export const PortfolioCard = ({ item, index = 0 }) => {
  const [broken, setBroken] = useState(false);
  const src = assetUrl(item.image_src ?? item.image_url);
  return (
  <article data-testid={`portfolio-card-${item.id}`}
    className="card-tech rise group flex flex-col overflow-hidden rounded-2xl"
    style={{ animationDelay: `${index * 80}ms` }}>
    <div className="relative aspect-[16/10] overflow-hidden bg-[#0D111A]">
      {src && !broken ? (
        <img src={src} alt={item.name} loading="lazy" onError={() => setBroken(true)} data-testid={`portfolio-card-image-${item.id}`}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
      ) : (
        <div data-testid={`portfolio-card-placeholder-${item.id}`} className="bg-grid grid h-full w-full place-items-center">
          <span className="font-display text-4xl font-bold text-cyan-300/70">{item.name.slice(0, 1).toUpperCase()}</span>
        </div>
      )}
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 data-testid={`portfolio-card-name-${item.id}`} className="text-xl font-semibold tracking-tight text-white">{item.name}</h3>
      <p data-testid={`portfolio-card-description-${item.id}`} className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{item.description}</p>
      <a href={item.url} target="_blank" rel="noopener noreferrer" data-testid={`portfolio-visit-link-${item.id}`}
        className="mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-cyan-400/30 px-4 py-2 text-sm font-medium text-cyan-300 transition-colors duration-200 hover:border-cyan-300 hover:bg-cyan-400/10 hover:text-white">
        Visit site <ExternalLink className="h-3.5 w-3.5" />
      </a>
    </div>
  </article>
  );
};
